module.exports = __webpack_public_path__ + "img/icon12.3319a1f9.png";